import { Component, OnInit, ViewChildren } from '@angular/core';
import { SesionService } from 'src/app/core/services/sesion.service';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BrokerService } from 'src/app/core/services/broker.service';
import { DataLayerService } from 'src/app/core/services/data-layer.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';

declare var $: any;

@Component({
  standalone: false,
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
	loginUrl: any;
	// private jsonUrl = 'https://images-s3-ecs-sp-latam.s3.amazonaws.com/catchupon/aliados/aliados.json';
	public dataJsonAliados: any[] = [];
	public testimonials: any[] = [];
	public linkLogin = environment.urlLoginMidc + '&view=pntd';
	@ViewChildren('testimonials') things: any;

	constructor(
		public sesion: SesionService,
		public router: Router,
		private http: HttpClient,
		private brokerService: BrokerService,
		private dlService: DataLayerService,
		public utilities: UtilitiesService) {
		this.loginUrl = environment.urlLoginMidc + '&view=pntd';
		router.events.subscribe((val) => {
			if (val instanceof NavigationEnd) {
				if (val.url == "/" || val.url.toLocaleLowerCase().includes('utm')) {
					this.utilities.getUtmParams();
				}
			}
		});
	}

	ngOnInit() {
		this.dlService.dl_userId(null, 'anonimo');
		if (this.sesion.sesionCookie != '' && this.sesion.sesionCookie != null) {
			this.router.navigate(['/deudas']);
		}
		this.setAliados();
		//this.getJsonAliados();
	}

	ngAfterViewInit() {
		this.setBanners();
		this.things.changes.subscribe((t: any) => {
			this.setQualify();
		});
	}

	/**
	 * Funcion para abrir o cerrar el collapse de faqs
	 */
	collpase() {
		$('.arrow-rotate').toggleClass('rotate0');
		$('.info-agreement').collapse('toggle');
		$('#seleccionarAcuerdo').toggleClass('d-flex');
	}

	/**
	 * Funcion para rotar la flecha del collapse cuando se despliga o oculta
	 * @param item 
	 */
	rotate(item: any) {
		var pru = !item;
		var pru2 = item;
		var btnArrow = $('#answer' + item);
		var menuItem = $('.btnCollapse');
		if (menuItem.attr("aria-expanded") === 'true') {
			btnArrow.addClass('rotate0');
		} else {
			btnArrow.removeClass('rotate0');
		}
	}

	/**
	 * Funcion para validar si la estrella debe ir habilitada o no en los testimoniales
	 * @param start posicion de la estrella
	 * @param qualify calificacion del testimonio
	 * @returns clase para deshabilitar o no
	 */
	validarEstrella(start: any, qualify: any) {
		if (start <= qualify) {
			return "orange";
		} else {
			return "disabled";
		}
	}
	/**
	 * Funcion que llama al archivo aliados.json que esta en el s3 para cargar los aliados y testimoniales
	 */
	setAliados() {
		this.brokerService.getAllies().subscribe({
			next: (res: any) => {
				// this.dataJsonAliados = res.aliados;
				this.testimonials = res.testimonials;
				if (this.sesion.isEmpty(this.sesion.allLogos)) {
					this.brokerService.getAllLogos().subscribe({
						next: (result: any) => {
							this.sesion.allLogos = result;
							if (this.sesion.allLogos.homePAD != undefined) {
								this.dataJsonAliados = this.sesion.allLogos.homePAD;
							}
						}
					});
				} else if (this.sesion.allLogos.homePAD != undefined) {
					this.dataJsonAliados = this.sesion.allLogos.homePAD;
				}
			}
		});
	}

	/**
	 * Función que dirige al login de la aplicación, además envia el data layer "clic_inside_tool" cada vez que se
	 * da click en este evento.
	 * @param btn_text Se recibe el texto del botón, para asimismo enviarlo al data layer
	 * @param btn_option Recibe la url a direccionar.
	 */
	enviarDataLayer(btn_text: string, btn_option: string) {
		// GA4 - clic_inside_tool
		this.dlService.dl_eventoGA4_button('clic_inside_tool', btn_text);
		if (btn_option == 'login') {
			window.location.href = this.loginUrl;
		}

		if (btn_option == 'midc') {
			window.location.href = environment.urlLoginMidc;
		}
	}

	viewInfo(info: number) {
		let box = document.getElementById('box-detail-' + info) as any;
		if (info == 1) {
			let otherBox = document.getElementById('box-detail-2') as any;
			otherBox.classList.add('d-none');
		} else {
			let otherBox = document.getElementById('box-detail-1') as any;
			otherBox.classList.add('d-none');
		}
		box.classList.remove('d-none');
	}
	goHome() {
		if (this.sesion.loggedIn) {
			this.router.navigate(['/']);
		} else {
			window.location.href = this.linkLogin;
		}
	}

	async setBanners() {
		let sizeTop = [[728, 90], [300, 250]];
		await this.utilities.addPubliById(environment.slotsBanners.padYa1, 'div-gpt-ad-1720186614588-0', sizeTop);
		// setTimeout(() => {
		await this.utilities.addPubliById(environment.slotsBanners.padYa2, 'div-gpt-ad-1720187114721-0', sizeTop);
		// }, 100);
	}

	setQualify() {
		this.testimonials.forEach((ele: any, index: number) => {
			let boxStars = document.getElementById('qualify-testimonial-' + index);
			let boxStarsM = document.getElementById('qualify-testimonial-m-' + index);
			let totalStar = 5;
			if (boxStars != undefined && boxStarsM != undefined) {
				for (let index = 0; index < ele.qualify; index++) {
					let node = document.createElement('i');
					node.style.color = '#F39734';
					node.style.marginRight = '2px';
					node.classList.add('fa', 'fa-star', 'orange');
					boxStars.appendChild(node.cloneNode(true));
					boxStarsM.appendChild(node.cloneNode(true));
				}
				for (let index = 0; index < totalStar - ele.qualify; index++) {
					let node = document.createElement('i');
					node.style.marginRight = '2px';
					node.classList.add('fa', 'fa-star');
					boxStars.appendChild(node.cloneNode(true));
					boxStarsM.appendChild(node.cloneNode(true));
				}
			}
		})
	}

}
